<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.edit_additional_details && localService.languageContent.common">
  <app-popup-header
    title="{{isPickMode ? localService.languageContent.edit_additional_details.delivery_address : localService.languageContent.edit_additional_details.header}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="wrapper">
      <div class="row" *ngIf="!isPickMode">
        <div class="col-4">
          <app-label [Text]="localService.languageContent.edit_additional_details.email"></app-label>
        </div>
        <div class="col-8">
          <input autocomplete="off" [ngClass]="wrapper.details.v1 != '' ? 'en' : ''" type="text"
            [(ngModel)]="wrapper.details.v1" (input)="onEmailInput()"
            placeholder="{{localService.languageContent.edit_additional_details.email}}"
            title="{{localService.languageContent.edit_additional_details.email}}" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-otp-container *ngIf="isVerificationPart" [PhNumOrEmail]="wrapper.details.v1" [otpType]="10"
            (onVerified)="onEmailVerified()"></app-otp-container>
        </div>
      </div>
      <div class="row" *ngIf="!isPickMode">
        <div class="col-4">
          <app-label [Text]="localService.languageContent.common.upi"></app-label>
        </div>
        <div class="col-8">
          <input autocomplete="off" [ngClass]="wrapper.details.v2 != '' ? 'en' : ''" type="text"
            [(ngModel)]="wrapper.details.v2" placeholder="{{localService.languageContent.common.upi}}"
            title="{{localService.languageContent.common.upi}}" />
        </div>
      </div>
      <div *ngIf="isPickMode">
        <div class="row" *ngIf="wrapper.deliveryAddress.length > 0">
          <div class="col-12">
            <div *ngIf="!isAddNewAddress">
              <div>
                <label>{{localService.languageContent.edit_additional_details.select_address}}</label>
              </div>
              <ngx-select id="{{elementIds.dd_select_address}}" [(ngModel)]="selectedAddress" [optionValueField]="'key'"
                [optionTextField]="'v2'" [items]="wrapper.deliveryAddress" [noAutoComplete]="true"
                (open)="showHideDummyHeight(true)" (close)="showHideDummyHeight(false)">
              </ngx-select>
              <div *ngFor="let item of wrapper.deliveryAddress">
                <div *ngIf="item.key == selectedAddress" style="margin:10px;opacity:0.7">
                  {{item.v3}}
                </div>
              </div>
            </div>
            <label style="font-weight: normal; margin-left: 15px;">
              <input type="checkbox" [(ngModel)]="isAddNewAddress" (change)="onChange()" />
              <span class="normal_color">{{localService.languageContent.edit_additional_details.add_new_address}}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isAddNewAddress">
        <div>
          <app-label [Text]="localService.languageContent.edit_additional_details.new_address"
            [IsNeedNewLine]="true"></app-label>
        </div>
        <div>
          <input autocomplete="off" type="text" id="{{elementIds.txt_address_title}}"
            [(ngModel)]="wrapper.newAddress.v2"
            placeholder="{{localService.languageContent.edit_additional_details.address_title}}"
            title="{{localService.languageContent.edit_additional_details.address_title}}" />
        </div>
        <div>
          <textarea rows="3" [(ngModel)]="wrapper.newAddress.v3"
            placeholder="{{localService.languageContent.edit_additional_details.new_address}}"
            title="{{localService.languageContent.edit_additional_details.new_address}}"></textarea>
        </div>
      </div>
      <div class="row" *ngIf="!isPickMode && wrapper.deliveryAddress && wrapper.deliveryAddress.length > 0">
        <div>
          <label>
            {{localService.languageContent.edit_additional_details.added_address}}
          </label>
        </div>
        <div class="row" *ngFor="let item of wrapper.deliveryAddress;index as idx">
          <div class="box">
            <div>
              <input autocomplete="off" type="text" id="{{elementIds.txt_address_title+'_'+(idx+1)}}"
                *ngIf="editedKey == item.key" [(ngModel)]="item.v2" style="width: calc(100% - 80px);"
                placeholder="{{localService.languageContent.edit_additional_details.address_title}}"
                title="{{localService.languageContent.edit_additional_details.address_title}}" />
              <button class="button_icon" *ngIf="editedKey != item.key"
                title="{{item.v1 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                (click)="onAction(1,item.key)" [ngStyle]="{'color': item.v1 == '1' ? 'yellowgreen' : 'orangered' }">
                {{item.v1 == '1' ? "toggle_on" :
                "toggle_off"}}
              </button>
              <span *ngIf="editedKey != item.key">&nbsp;<b>{{item.v2}}</b></span>
              <button class="button_icon button_icon_color icon_adjust" *ngIf="editedKey != item.key"
                title="{{localService.languageContent.common.edit}}" (click)="onAction(3,item.key,idx)"
                style="margin-left: 10px;">
                edit
              </button>
              <button class="button_icon" *ngIf="editedKey != item.key"
                title="{{localService.languageContent.table.remove}}" (click)="onAction(2,item.key)"
                style="color:red;float:right;">
                delete
              </button>
              <button class="button_icon button_icon_color" *ngIf="editedKey == item.key"
                title="{{localService.languageContent.common.save}}" (click)="onAction(4,item.key)"
                style="float:right;">
                save
              </button>
              <button class="button_icon button_icon_color" *ngIf="editedKey == item.key"
                title="{{localService.languageContent.common.cancel}}" (click)="onAction(5,item.key)"
                style="float:right;">
                cancel
              </button>
            </div>
            <div>
              <div *ngIf="editedKey == item.key">
                <textarea rows="3" [(ngModel)]="item.v3"
                  placeholder="{{localService.languageContent.edit_additional_details.new_address}}"
                  title="{{localService.languageContent.edit_additional_details.new_address}}"></textarea>
              </div>
              <div *ngIf="editedKey != item.key">
                {{item.v3}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isShowDummyHeight" [ngStyle]="{'height' : localService.getHeightOfOpenedControls('2') + 'px'}">
        &nbsp;
      </div>
    </div>
  </div>
  <div class="modal-footer" *ngIf="editedKey == ''">
    <button type="button" class="btn btn-primary"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>